// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import { API_URL } from './constants';
import App from './App';

import './plugins/cookie/index';
import './plugins/lodash/index';
import './plugins/wysiwyg/index';
import './plugins/nl2br/index';
// import { configureExceptionHandling } from './utils/exception_handler';
import api from './api/index';
import store from './store/index';
import router from './router/index';
import i18n from './i18n/index';
import './ui/index';

import './filters';
import './directives';
import './components';

Vue.config.productionTip = false;

// Configure Exception Handler
// configureExceptionHandling(() => {
//   router.replace({ name: 'error' });
// });

api.configure({
  baseUrl: API_URL,
  defaultHeaders: {
    'Content-Type': 'application/json',
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js